<template lang="pug">
  v-expansion-panels
    v-expansion-panel
      v-expansion-panel-header.title Enable signals
      v-expansion-panel-content
        v-row(no-gutters)
          v-col(:cols="4" v-for="(signalLabel, signalKey) in signalLabels")
            v-switch(
                color="success"
                inset
                :label="signalLabel"
                v-model="signalsToPlot"
                :value="signalKey"
                v-bind:key="signalKey")

</template>

<script>
export default {
  components: {},
  computed: {
    simulation() {
      return this.$store.state.simulation.simulation;
    },
    signalsToPlot: {
      get: function() {
        return this.$store.state.chartData.signalsToPlot;
      },
      set: function(newValue) {
        this.$store.state.chartData.signalsToPlot = newValue;
      }
    },
    signalLabels() {
      return this.$store.state.chartData.signalLabels;
    },
    chartOptions() {
      return this.$store.state.chartData.options;
    },
    chartData() {
      return this.$store.state.chartData.data;
    }
  },
  data: function() {
    return {
      signalAccel: true,
      switch1: true
    };
  }
};
</script>

<style></style>
